export default {
  'method-card': {
    'add-account': 'Add Account',
    'processing-time': 'Processing Time',
    fee: 'Fee',
    limits: 'Limits',
    'arrival-time-description': 'Follows the withdrawal method',
    'fee-description': 'Charged according to the withdrawal method',
    'limit-description': 'Withdrawal amount follows the withdrawal method',
    'wallet-address': 'Wallet Address',
    'bank-name': 'China Construction Bank Beijing Zhongguancun Branch',
    'card-number': 'Card Number:',
    delete: 'Delete',
    edit: 'Edit',
  },
}
